import React, {Component} from 'react';
import IconWarning from '../style/icon/IconWarning'

class DeviceDIN extends Component {
  handleClick(dev) {
    this.props.onClick(dev)
  }

  render() {
    const {icon, device} = this.props
    return <div onClick={() => this.handleClick(device)}>
      <span>{icon}</span>
      {
        !device.Disconnected
          ? <div className="value">
              <span className="number"></span>
            </div>
          : <div className="value">
              <span className="disconnected"><IconWarning/></span>
            </div>
      }
      <span style={{
          color: device.Color
        }}>{device.Name}</span>
    </div>
  }
}

export default DeviceDIN;



// WEBPACK FOOTER //
// ./src/components/DeviceDIN.js